module.exports = __webpack_public_path__ + "media/images/photoswipe/preloader-14d740b6ee64510747b03b411d46f200.gif";